module.exports = __webpack_public_path__ + "media/images/pic/contact/agnieszka-zieba-26fb98bb46a5295d454ac5da7d42bd83.jpeg";